var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.18 38.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.84 24.12a6.24 6.24 0 1 0 6.08 6.41v-.18h0a6.19 6.19 0 0 0-6.08-6.23m-33.46 0a6.24 6.24 0 1 0 6.07 6.41v-.18h0a6.18 6.18 0 0 0-6.07-6.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.26 16.75a2.31 2.31 0 0 0-2.18-2.41l-4.25-1L58 3.14a2.19 2.19 0 0 0-2.09-1.64H6.38a3.25 3.25 0 0 0-3.27 3.24h0V27h7.74a7.16 7.16 0 0 1 9.6-3.26l.12.06a7.34 7.34 0 0 1 3.16 3.2h20.64a7.14 7.14 0 0 1 9.55-3.28l.16.08a7.3 7.3 0 0 1 3.16 3.2h10zM1.5 28.56h8.6m14.66 0h19.09m13 0h11.83M4.11 13.37h56.21M22.47 1.62v11.5m19.51-11.5v11.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadTransfer);
export default __webpack_public_path__ + "static/media/roadTransfer.39953ee270eac1f273969c15ca444583.svg";
export { ForwardRef as ReactComponent };